import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateLoader } from '@ngx-translate/core';

declare var require: any;

@Injectable({
  providedIn: 'root'
})
export class MultiTranslateService implements TranslateLoader {
  constructor(private http: HttpClient) {}

  public getTranslation(language: string): Observable<any> {
    const translationFiles: string[] = this.getSelectedFilePaths(language);
    const requests: any = translationFiles.map((translationFile: string) => {
      return this.http.get(`/assets/i18n/${translationFile}`, {
        params: { rand: '' + Math.round(Math.random() * 10000000) }
      });
    });
    return forkJoin(requests).pipe(
      map((response: any) => {
        return response.reduce((a: any, b: any) => {
          return Object.assign(a, b);
        });
      })
    );
  }

  private getSelectedFilePaths(language: string): string[] {
    const allFiles: string[] = this.getAllFilePaths();
    const languageFiles: string[] = [];
    allFiles.forEach((filePath: string) => {
      if (filePath.startsWith(language, 2)) {
        filePath = filePath.replace(new RegExp(`^./([^.]+)`), (_: string, b: string) => b);
        languageFiles.push(filePath);
      }
    });
    return languageFiles;
  }

  private getAllFilePaths(): string[] {
    return ((context: any): string[] => {
      return context.keys();
    })(require.context(`../../../assets/i18n`, true, /.json/));
  }
}
